import { render, staticRenderFns } from "./SelectWorkflow.vue?vue&type=template&id=3ef95f24"
import script from "./SelectWorkflow.vue?vue&type=script&lang=js"
export * from "./SelectWorkflow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports